import useTranslation from '@/utils/hooks/translation/useTranslation';

type TitleOptionProps = {
    title: string;
    subtitle: string;
};

export const TitleOption = ({ title, subtitle }: TitleOptionProps) => {
    const { t } = useTranslation('giveaway_picker');

    return (
        <div>
            <p className="mb-1.5 flex items-center justify-between text-icoBlack">{t(title)}</p>
            <p className="font-GMedium text-xs text-icoGray-400">{t(subtitle)}</p>
        </div>
    );
};
